<ng-template #template>
  <div
    class="card-spacing"
    [ngClass]="[
      'col-lg-' + width,
      needpaddingLeft ? 'pr-lg-0' : 'p-lg-0',
      isZoom ? 'zoomed' : ''
    ]"
  >
    <div class="card h-100">
      <div class="card-body">
        <h2>{{ data?.title }}</h2>
        <a
          (click)="zoom()"
          class="zoom"
          *ngIf="data.zoomInfo"
          [attr.aria-label]="'Zoom ' + data?.title"
          href="javascript:void(0)"
          ><img src="img/magnifier.svg" width="20px" class="zoom-chart"
        /></a>
        <canvas
          id="chart1"
          baseChart
          [datasets]="barChartData"
          [labels]="barChartLabels"
          [options]="barChartOptions"
          [colors]="lineChartColors"
          [chartType]="barChartType"
        ></canvas>
      </div>
    </div>
  </div>
</ng-template>
